import { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const InfiniteScrollList = ({ fetchItems, renderItem, data, hasMore, showMessageEnd }) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation("common");
  const observer = useRef();

  async function loadMoreItems() {
    if (!loading && hasMore) {
      setLoading(true);

      try {
        await fetchItems();
      } catch (error) {
        console.error("Erreur lors du chargement des éléments :", error);
      }

      setLoading(false);
    }
  }

  function lastItemRef(node) {
    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && hasMore) loadMoreItems();
    });

    if (node) observer.current.observe(node);
  }

  useEffect(() => {
    loadMoreItems();
  }, []);

  return (
    <>
      {data.map((item, index) => {
        if (index === data.length - 1) {
          if (!hasMore && showMessageEnd) {
            return (
              <div ref={lastItemRef} key={index}>
                {renderItem(item, index)}
                <p
                  className="noMoreData"
                  style={{
                    textAlign: "center",
                    fontSize: "15px",
                  }}
                >
                  {t("noMoreData")}
                </p>
              </div>
            );
          }

          return (
            <div ref={lastItemRef} key={index}>
              {renderItem(item, index)}
            </div>
          );
        }
        return renderItem(item, index);
      })}

      {loading && <p className="text-center text-gray-400">{t("loading")}</p>}
    </>
  );
};

InfiniteScrollList.propTypes = {
  fetchItems: PropTypes.func.isRequired,
  renderItem: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  hasMore: PropTypes.bool.isRequired,
};

export default InfiniteScrollList;
